<template>
  <div v-if="orderDebt" class="row">
    <div class="col-8">
      <h4 class="d-inline-block">Deuda en Dólares</h4>
      <span class="float-right">{{ debtInDollars | toCurrencyUSD }}</span>
    </div>

    <div class="col-8">
      <h4 class="d-inline-block">Deuda en Pesos ({{ orderDollarQuote | toCurrencyARS }})</h4>
      <span class="float-right">{{ debtInPesos | toCurrencyARS }}</span>
    </div>

    <div class="col-8">
      <h4 class="d-inline-block">Deuda en Pesos Actualizada ({{ currentDollarQuote | toCurrencyARS }})</h4>
      <span class="float-right">{{ (debtInDollars * currentDollarQuote) | toCurrencyARS }}</span>
    </div>

    <div class="col-8">
      <h4 class="d-inline-block">Diferencia de Cotización</h4>
      <span class="float-right">{{ diffQuotation | toCurrencyARS }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DebtInfo',

  props: {
    orderDollarQuote: {
      type: [String, Number],
      default: 0,
    },

    currentDollarQuote: {
      type: [String, Number],
      default: 0,
    },

    debtInDollars: {
      type: Number,
      default: 0,
    },

    debtInPesos: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapState('models/order', { orderDebt: 'debt' }),

    diffQuotation() {
      return Math.abs(this.debtInDollars * this.currentDollarQuote - this.debtInDollars * this.orderDollarQuote);
    },
  },
};
</script>
